const ENTRY_KEY = 'pd10913.funnel-entered'

/**
 * The CTA path enters the funnel with an empty lead store, so the guard can't
 * read the lead the way FlowGuard does. Both homepage entry points set this
 * marker instead; the thank-you page clears it so the back button can't re-enter.
 *
 * Every /v2 page declares this in place of the FlowGuard it inherits from
 * AbstractFormPage: FlowGuard only passed there because the client bootstrap
 * writes country and language, and `lead/reset` on submit takes those away.
 */
export function markFunnelEntered() {
  try {
    sessionStorage.setItem(ENTRY_KEY, '1')
  } catch {}
}

/**
 *
 */
export function clearFunnelEntered() {
  try {
    sessionStorage.removeItem(ENTRY_KEY)
  } catch {}
}

/**
 * @param {object} context
 * @param {Function} context.redirect
 * @returns {*}
 */
export default function variantGuardPD10913({ redirect }) {
  if (!process.client) {
    return
  }

  let entered = false

  try {
    entered = sessionStorage.getItem(ENTRY_KEY) === '1'
  } catch {}

  if (!entered) {
    return redirect('/')
  }
}
